import { useAuth } from "@/hooks/use-auth";
import { usePlanWorkspace } from "@/hooks/use-platform-billing";
import { wantsPrpHome } from "@/lib/prp-home";

/**
 * PRP mode: the PRP workspace shell is the whole app - every page (schedule,
 * groups, settings…) renders inside it with the PRP sidebar. On for every
 * user of a PRP Programs plan, and for PRP staff logins in any clinic.
 * Doctors, nurses and admins of a full-EHR clinic keep the main app.
 */
export function usePrpMode() {
  const { user } = useAuth();
  const { prpOnly, isLoading } = usePlanWorkspace();
  const prpStaff = wantsPrpHome(user?.role);
  return {
    prpMode: prpStaff || prpOnly,
    prpOnlyOrg: prpOnly,
    // PRP staff are known from the login; others wait for the plan.
    isLoading: !prpStaff && isLoading,
  };
}
